import { setTokens } from "@/usecase/token-operators";
import { logout as logoutApi } from "@/api/adapter.api";

export async function logout() {
  // Logout directly regardless to tokens and do not popup login UI when refresh/access tokens are expired on logout access
  await logoutApi();
  setTokens(undefined, undefined);
}
